<template>
  <section>
    <div class="container box mt-5">
      <div class="content mb-6 has-text-centered">
        <h1>Gestión de Actividades Académicas</h1>
      </div>
      <div class="columns">
        <div class="column">
          <div class="title is-5">
            Listado de las Actividades Académicas
            <hr class="dropdown-divider" aria-role="menuitem" />
          </div>
        </div>
      </div>
      <b-tabs position="is-centered">
        <b-tab-item
          v-for="(academic_area, index) in academic_areas"
          :key="index"
          :label="
            academic_area.alt_name === 'Extensión'
              ? 'VIME'
              : academic_area.alt_name
          "
        >
          <div class="is-flex is-justify-content-right mb-4">
            <b-button
              icon-left="plus"
              type="is-primary"
              @click="openNewModal(academic_area.id)"
            >
              Nueva Actividad Académica
            </b-button>
          </div>

          <b-table
            :data="academic_area.academic_activities"
            paginated
            per-page="10"
            :pagination-simple="false"
            pagination-position="bottom"
            aria-next-label="Siguiente"
            aria-previous-label="Anterior"
            aria-page-label="Página"
            aria-current-label="Página actual"
            detail-icon="plus-circle"
          >
            <b-table-column field="alt_name" label="Nombre" v-slot="props">
              {{ props.row.alt_name }}
            </b-table-column>
            <b-table-column
              field="max_hours"
              label="Horas Máximas"
              v-slot="props"
            >
              {{ props.row.max_hours || "No definido" }}
            </b-table-column>
            <b-table-column
              field="requires_subject"
              label="Requiere Asignatura"
              v-slot="props"
            >
              <span
                class="tag is-medium"
                :class="props.row.requires_subject ? 'is-success' : 'is-danger'"
              >
                {{ props.row.requires_subject ? "Sí" : "No" }}
              </span>
            </b-table-column>
            <b-table-column
              field="requires_program_type"
              label="Requiere tipo de programa"
              v-slot="props"
            >
              <span
                class="tag is-medium"
                :class="
                  props.row.requires_program_type ? 'is-success' : 'is-danger'
                "
              >
                {{ props.row.requires_program_type ? "Sí" : "No" }}
              </span>
            </b-table-column>
            <!-- <b-table-column field="enabled" label="Habilitada" v-slot="props">
              <span
                class="tag"
                :class="props.row.enabled ? 'is-success' : 'is-danger'"
              >
                {{ props.row.enabled ? "Sí" : "No" }}
              </span>
            </b-table-column> -->
            <b-table-column label="Acciones" width="240px" v-slot="props">
              <b-button
                label="Editar"
                icon-left="edit"
                type="is-warning"
                @click="
                  openModal = true;
                  academic_activity = { ...props.row };
                "
              >
                Editar
              </b-button>
              <b-button
                icon-left="trash"
                type="is-danger"
                @click="
                  validateDisableAcademicActivity(
                    props.row.alt_name,
                    props.row.id
                  )
                "
              >
                Eliminar
              </b-button>
            </b-table-column>
          </b-table>
        </b-tab-item>
      </b-tabs>
    </div>
    <b-modal
      :active.sync="openModal"
      :width="640"
      aria-modal
      has-modal-card
      :destroy-on-hide="true"
      aria-role="dialog"
      :can-cancel="['escape']"
    >
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(updateAcademicActivity)">
          <div class="modal-card">
            <div class="modal-card-head">
              <p class="modal-card-title">Editar Actividad Académica</p>
              <button
                class="delete"
                aria-label="close"
                @click="openModal = false"
              ></button>
            </div>
            <section class="modal-card-body">
              <b-field label="Nombre de la Actividad Académica">
                <ValidationProvider
                  rules="required|min:5|max:200"
                  v-slot="{ errors }"
                >
                  <b-input
                    v-model="academic_activity.alt_name"
                    placeholder="Ingrese el nombre de la actividad"
                  ></b-input>
                  <span class="validation-alert">{{ errors[0] }}</span>
                </ValidationProvider>
              </b-field>
              <b-field label="Horas Máximas">
                <ValidationProvider
                  :rules="{ regex: /^(\d{1,2}(\.\d)?|100(\.0)?)$/ }"
                  name="horas máximas"
                  :custom-messages="{
                    regex:
                      'Tiene que ser un número válido con un decimal como máximo y valor máximo 100',
                  }"
                  v-slot="{ errors }"
                >
                  <b-input
                    v-model="academic_activity.max_hours"
                    type="text"
                    placeholder="Ingrese las horas máximas. EJ: 4 o 4.5"
                  ></b-input>
                  <span class="validation-alert">{{ errors[0] }}</span>
                </ValidationProvider>
              </b-field>
              <div class="columns">
                <div class="column">
                  <b-field label="Requiere Asignatura">
                    <b-checkbox
                      v-model="academic_activity.requires_subject"
                      :true-value="true"
                      :false-value="false"
                    >
                      Sí, requiere asignatura
                    </b-checkbox>
                  </b-field>
                </div>
                <div class="column">
                  <b-field label="Requiere Tipo de Programa">
                    <b-checkbox
                      v-model="academic_activity.requires_program_type"
                      :true-value="true"
                      :false-value="false"
                    >
                      Sí, requiere tipo de programa
                    </b-checkbox>
                  </b-field>
                </div>
              </div>
            </section>
            <footer class="modal-card-foot">
              <button class="button is-primary" type="submit">
                Guardar Cambios
              </button>
              <button class="button" type="button" @click="openModal = false">
                Cancelar
              </button>
            </footer>
          </div>
        </form>
      </ValidationObserver>
    </b-modal>
    <b-modal
      :active.sync="openModalNew"
      :width="640"
      aria-modal
      has-modal-card
      :destroy-on-hide="true"
      aria-role="dialog"
      :can-cancel="['escape']"
    >
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(createAcademicActivity)">
          <div class="modal-card">
            <div class="modal-card-head">
              <p class="modal-card-title">Nueva Actividad Académica</p>
              <button
                class="delete"
                aria-label="close"
                @click="openModalNew = false"
              ></button>
            </div>
            <section class="modal-card-body">
              <b-field label="Nombre de la Actividad Académica">
                <ValidationProvider
                  rules="required|min:5|max:200"
                  v-slot="{ errors }"
                >
                  <b-input
                    v-model="new_academic_activity.alt_name"
                    placeholder="Ingrese el nombre de la actividad"
                  ></b-input>
                  <span class="validation-alert">{{ errors[0] }}</span>
                </ValidationProvider>
              </b-field>
              <b-field label="Horas Máximas">
                <ValidationProvider
                  :rules="{ regex: /^(\d{1,2}(\.\d)?|100(\.0)?)$/ }"
                  name="horas máximas"
                  :custom-messages="{
                    regex:
                      'Tiene que ser un número válido con un decimal como máximo y valor máximo 100',
                  }"
                  v-slot="{ errors }"
                >
                  <b-input
                    v-model="new_academic_activity.max_hours"
                    type="text"
                    placeholder="Ingrese las horas máximas. EJ: 4 o 4.5"
                  ></b-input>
                  <span class="validation-alert">{{ errors[0] }}</span>
                </ValidationProvider>
              </b-field>
              <div class="columns">
                <div class="column">
                  <b-field label="Requiere Asignatura">
                    <b-checkbox
                      v-model="new_academic_activity.requires_subject"
                      :true-value="true"
                      :false-value="false"
                    >
                      Sí, requiere asignatura
                    </b-checkbox>
                  </b-field>
                </div>
                <div class="column">
                  <b-field label="Requiere Tipo de Programa">
                    <b-checkbox
                      v-model="new_academic_activity.requires_program_type"
                      :true-value="true"
                      :false-value="false"
                    >
                      Sí, requiere tipo de programa
                    </b-checkbox>
                  </b-field>
                </div>
              </div>
            </section>
            <footer class="modal-card-foot">
              <button class="button is-primary" type="submit">
                Crear Actividad
              </button>
              <button
                class="button"
                type="button"
                @click="openModalNew = false"
              >
                Cancelar
              </button>
            </footer>
          </div>
        </form>
      </ValidationObserver>
    </b-modal>
    <b-loading :is-full-page="true" v-model="isLoading" :can-cancel="false" />
  </section>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      academic_areas: [],
      isLoading: false,
      openModal: false,
      openModalNew: false,
      academic_activity: {
        id: null,
        alt_name: "",
        max_hours: null,
        requires_subject: false,
        enabled: true,
      },
      new_academic_activity: {
        alt_name: "",
        max_hours: null,
        requires_subject: false,
        enabled: true,
        academic_area_id: null,
      },
    };
  },
  created() {
    this.getAcademicAreas();
  },
  methods: {
    getAcademicAreas() {
      this.isLoading = true;
      axios
        .get("/academic_areas.json")
        .then((response) => {
          this.academic_areas = response.data;
        })
        .catch((error) => {
          this.$buefy.dialog.alert({
            title: "Error",
            message: "Hubo un error al obtener los datos. Intente más tarde.",
            type: "is-danger",
            hasIcon: true,
            iconPack: "fa",
            icon: "times-circle",
            confirmText: "Ok",
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    updateAcademicActivity() {
      this.isLoading = true;
      axios
        .put(`/academic_activities/${this.academic_activity.id}.json`, {
          academic_activity: this.academic_activity,
        })
        .then((response) => {
          this.$buefy.dialog.alert({
            title: "Éxito",
            message: "Actividad Académica actualizada correctamente.",
            type: "is-success",
            hasIcon: true,
            iconPack: "fa",
            icon: "check-circle",
            confirmText: "Ok",
          });
          this.openModal = false;
          this.getAcademicAreas();
        })
        .catch((error) => {
          this.$buefy.dialog.alert({
            title: "Error",
            message:
              "Hubo un error al actualizar la actividad. Intente más tarde.",
            type: "is-danger",
            hasIcon: true,
            iconPack: "fa",
            icon: "times-circle",
            confirmText: "Ok",
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    validateDisableAcademicActivity(activity_name, id) {
      this.isLoading = true;
      axios
        .get(`/academic_activities/used-academic-activities/${id}.json`)
        .then((response) => {
          if (response.data.used) {
            this.$buefy.dialog.confirm({
              title: "Confirmación",
              message: `La actividad académica "${activity_name}" está siendo utilizada y se encuentra el proceso abierto. Se sugiere no eliminar. ¿Está seguro de que desea eliminarla?`,
              type: "is-warning",
              hasIcon: true,
              iconPack: "fa",
              icon: "exclamation-triangle",
              confirmText: "Sí, eliminar",
              cancelText: "Cancelar",
              onConfirm: () => {
                this.disableAcademicActivity(id);
              },
            });
          } else {
            this.$buefy.dialog.confirm({
              title: "Confirmación",
              message: `¿Está seguro de que desea eliminar la actividad académica "${activity_name}"? Podría estar siendo utilizada en registros históricos.`,
              type: "is-warning",
              hasIcon: true,
              iconPack: "fa",
              icon: "exclamation-triangle",
              confirmText: "Sí, eliminar",
              cancelText: "Cancelar",
              onConfirm: () => {
                this.disableAcademicActivity(id);
              },
            });
          }
        })
        .catch((error) => {
          this.$buefy.dialog.alert({
            title: "Error",
            message:
              "Hubo un error al verificar el uso de la actividad. Intente más tarde.",
            type: "is-danger",
            hasIcon: true,
            iconPack: "fa",
            icon: "times-circle",
            confirmText: "Ok",
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    disableAcademicActivity(id) {
      this.isLoading = true;
      axios
        .put(`/academic_activities/disable-academic-activities/${id}.json`)
        .then((response) => {
          this.$buefy.dialog.alert({
            title: "Éxito",
            message: "Actividad Académica deshabilitada correctamente.",
            type: "is-success",
            hasIcon: true,
            iconPack: "fa",
            icon: "check-circle",
            confirmText: "Ok",
          });
          this.getAcademicAreas();
        })
        .catch((error) => {
          this.$buefy.dialog.alert({
            title: "Error",
            message:
              "Hubo un error al deshabilitar la actividad. Intente más tarde.",
            type: "is-danger",
            hasIcon: true,
            iconPack: "fa",
            icon: "times-circle",
            confirmText: "Ok",
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    openNewModal(academic_area_id) {
      this.new_academic_activity = {
        alt_name: "",
        max_hours: null,
        requires_subject: false,
        enabled: true,
        academic_area_id: academic_area_id,
      };
      this.openModalNew = true;
    },
    createAcademicActivity() {
      this.isLoading = true;
      axios
        .post("/academic_activities.json", {
          academic_activity: this.new_academic_activity,
        })
        .then((response) => {
          this.$buefy.dialog.alert({
            title: "Éxito",
            message: "Actividad Académica creada correctamente.",
            type: "is-success",
            hasIcon: true,
            iconPack: "fa",
            icon: "check-circle",
            confirmText: "Ok",
          });
          this.openModalNew = false;
          this.getAcademicAreas();
        })
        .catch((error) => {
          this.$buefy.dialog.alert({
            title: "Error",
            message: "Hubo un error al crear la actividad. Intente más tarde.",
            type: "is-danger",
            hasIcon: true,
            iconPack: "fa",
            icon: "times-circle",
            confirmText: "Ok",
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>
